module.exports = __webpack_public_path__ + "media/images/athletes/1611-f4a468a0fe327f9e54131af3ef572d34.png";